import { S3 } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import moment from "moment-timezone";

export type FileLinkOpts = {
    file: File;
    fileLink?: string; // overrides link generated with buildLink
    companyId?: number | string; // defaults to 'unknown', used in filename
    category?: string; // defaults to 'logo_image', used in filename
    type?: string; // defaults to 'company', specifies bucket path
};
type UploadFileOpts = FileLinkOpts & {
    s3BucketRegion: string;
    s3AssetsBucket: string;
    awsCognitoPoolId: string;
    ACL?: "public-read" | "private";
};
function buildLink({
    file,
    companyId = "unknown",
    category = "company",
    type = "logo_image",
}: FileLinkOpts) {
    const fileEnd = file.type.substring(file.type.lastIndexOf("/") + 1);
    const currentDay = moment().format("YYYY-MM-DD");
    return `${category}/${companyId}_${type}_${currentDay}_${Date.now()}.${fileEnd}`;
}

export const getCognitoCredentials = async (region: string, poolId: string) => {
    const cognitoidentity = new CognitoIdentityClient({
        credentials: fromCognitoIdentityPool({
            client: new CognitoIdentityClient({ region }),
            identityPoolId: poolId,
        }),
    });
    return cognitoidentity.config.credentials();
};

export const uploadAWSFile = async ({
    s3BucketRegion,
    s3AssetsBucket,
    awsCognitoPoolId,
    ...opts
}: UploadFileOpts): Promise<string> => {
    const { file } = opts;

    if (!file) {
        throw Error("no file");
    }

    const fileLink = opts.fileLink || buildLink(opts);

    const credentials = await getCognitoCredentials(s3BucketRegion, awsCognitoPoolId);

    const s3 = new S3({
        apiVersion: "2006-03-01",
        region: s3BucketRegion,
        credentials,
    });

    const params = {
        Key: fileLink,
        Body: file,
        ContentType: file.type,
        ACL: opts.ACL || "public-read",
        Bucket: s3AssetsBucket,
    };

    return new Promise((resolve, reject) => {
        s3.putObject(params, (e: Error) => {
            if (e) {
                reject(e);
                return;
            }
            resolve(fileLink);
        });
    });
};
